// Lightweight analytics helper. Forwards events to GTM (window.dataLayer)
// and gtag (window.gtag) when present, and always logs a warning so issues
// are visible during development and in browser consoles in production.

type AnalyticsPayload = Record<string, unknown>;

declare global {
  interface Window {
    dataLayer?: AnalyticsPayload[];
    gtag?: (...args: unknown[]) => void;
  }
}

export const trackEvent = (event: string, payload: AnalyticsPayload = {}) => {
  if (typeof window === "undefined") return;

  const enriched: AnalyticsPayload = {
    event,
    ...payload,
    page_path: window.location.pathname,
    page_url: window.location.href,
    timestamp: new Date().toISOString(),
  };

  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(enriched);
    window.gtag?.("event", event, enriched);
  } catch {
    // Swallow — analytics should never break the app.
  }
};

export const trackVideoValidationFailure = (params: {
  slug: string;
  rawUrl: string;
  reason: "missing_url" | "invalid_url";
  lang?: string;
}) => {
  console.warn("[case-study-video] validation failure", params);
  trackEvent("case_study_video_invalid", {
    ...params,
    category: "case_study_video",
  });
};

export const trackVideoSlowLoad = (params: {
  slug: string;
  rawUrl: string;
  videoType: "youtube" | "local" | "remote";
  hasPoster: boolean;
  elapsedMs: number;
  lang?: string;
}) => {
  console.warn("[case-study-video] slow load", params);
  trackEvent("case_study_video_slow_load", {
    ...params,
    category: "case_study_video",
  });
};
